import { Grid, FormControlLabel, Checkbox } from '@mui/material'
import {
  CustomSelect,
  selectTypes,
} from 'src/consumer/components/helperComponents'
import PrescriptionSectionCard from './PrescriptionSectionCard'
import PictureUploadComponent from 'src/consumer/components/Helpers/PictureUploadComponent/PictureUploadComponent'
import PatientHistoryTipTapEditor from 'src/mentor/components/PrescriptionMakingPage/screeningReportViewer/components/PatientHistoryTipTapEditor'
import { Box } from '@mui/material'

const SIGNATURE_POSITION_OPTIONS = [
  { id: 'left', title: 'Left' },
  { id: 'right', title: 'Right' },
]

const PRACTITIONER_NAME_CASE_OPTIONS = [
  { id: 'small', title: 'Small case' },
  { id: 'capital', title: 'Capital case' },
]

/**
 * Section for signature configuration (signatureDetails payload).
 * Covers imageId, position, showPractitionerName, practitionerNameCase, showLicenseDetails, richText.
 * Legacy `signature` is kept in sync when imageId changes.
 */
export default function SignatureDetailsSection({
  prescriptionTemplate,
  handleChangeSignatureDetails,
  handleSignatureRichTextChange,
  disabled,
}) {
  const signatureDetails = prescriptionTemplate?.signatureDetails || {}
  const imageId = signatureDetails.imageId ?? prescriptionTemplate?.signature

  return (
    <PrescriptionSectionCard heading="Signature Details">
      <Grid item xs={12}>
        <PictureUploadComponent
          aspectHeight={50}
          showRemoveButton
          aspectWidth={100}
          id="imageId"
          value={imageId}
          title="Signature image"
          onChange={handleChangeSignatureDetails}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <CustomSelect
          id="signaturePosition"
          value={signatureDetails.signaturePosition ?? 'right'}
          options={SIGNATURE_POSITION_OPTIONS}
          onChangeEvent={handleChangeSignatureDetails}
          label="Signature position"
          disabled={disabled}
          getOptionValue={(option) => option?.id}
          getOptionLabel={(option) => option?.title}
          selectType={selectTypes.string}
        />
      </Grid>
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              id="showPractitionerName"
              checked={Boolean(signatureDetails.showPractitionerName !== false)}
              onChange={(e) =>
                handleChangeSignatureDetails({
                  target: { id: 'showPractitionerName', value: e.target.checked },
                })
              }
              disabled={disabled}
            />
          }
          label="Show practitioner name"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <CustomSelect
          id="practitionerNameCase"
          value={signatureDetails.practitionerNameCase ?? 'small'}
          options={PRACTITIONER_NAME_CASE_OPTIONS}
          onChangeEvent={handleChangeSignatureDetails}
          label="Practitioner name case"
          disabled={disabled}
          getOptionValue={(option) => option?.id}
          getOptionLabel={(option) => option?.title}
          selectType={selectTypes.string}
        />
      </Grid>
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              id="showLicenseDetails"
              checked={Boolean(signatureDetails.showLicenseDetails)}
              onChange={(e) =>
                handleChangeSignatureDetails({
                  target: { id: 'showLicenseDetails', value: e.target.checked },
                })
              }
              disabled={disabled}
            />
          }
          label="Show license details"
        />
      </Grid>
      <Grid item xs={12}>
        <Box sx={{ mb: 1, fontWeight: 600, fontSize: '14px', color: 'text.secondary' }}>
          Lines below signature (name, designation, etc.)
        </Box>
        <Box
          sx={{
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 1,
            overflow: 'hidden',
            maxHeight: 220,
          }}
        >
          <PatientHistoryTipTapEditor
            value={signatureDetails.richText ?? ''}
            onChange={handleSignatureRichTextChange}
            placeholder="e.g. Dr. Name, MBBS, MD"
            readOnly={disabled}
            scrollableContentArea
            maxHeightForScroll={200}
            containerDivStyles={{
              background: 'white',
              padding: 0,
              border: 'none',
              borderRadius: 0,
            }}
          />
        </Box>
      </Grid>
    </PrescriptionSectionCard>
  )
}
